import { Spinner } from '@/components/ui/Spinner';

interface ExportButtonProps {
  onExport: () => void;
  isExporting: boolean;
  disabled?: boolean;
}

export function ExportButton({ onExport, isExporting, disabled }: ExportButtonProps) {
  const isDisabled = disabled || isExporting;

  return (
    <button
      type="button"
      onClick={onExport}
      disabled={isDisabled}
      aria-label="Export performance data as CSV"
      className={`inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-all bg-dark-800 border border-dark-700 text-dark-200 hover:bg-dark-700 hover:text-dark-100 ${
        isDisabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
    >
      {isExporting ? (
        <Spinner size="sm" className="text-current" />
      ) : (
        <svg
          className="h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
          />
        </svg>
      )}
      {isExporting ? 'Exporting...' : 'Export CSV'}
    </button>
  );
}
